import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const apiKeyEntity: Entity = {
  model: model,
  repository: repository,
}

export default apiKeyEntity
